import {
    API
} from '../Api.class';

export class AdPlacementsAPI extends API {

    constructor(baseUrl) {
        super(baseUrl)

    }

    async hourlyImpressions(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/ad-placements/${id}/analytics/hourly/impressions`, {
            meta,
        })
    }

    async hourlyIdle(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/ad-placements/${id}/analytics/hourly/idle`, {
            meta,
        })
    }

}